/**
 * Configurator — cart Base64 codec + uid helper.
 *
 * encodeCart packs the cart into a compact, URL-safe Base64 token so the
 * user can share their configuration via any channel that supports a link.
 * The schema uses single-letter keys (c/s/w/h/co/me) to keep the URL short
 * even with many items.
 */

export function encodeCart(cart) {
  if (!cart || !cart.length) return '';
  const compact = cart.map((it) => ({
    c: it.category,
    s: it.slug,
    w: it.width,
    h: it.height,
    co: it.colorId,
    me: it.meshId,
  }));
  try {
    const json = JSON.stringify(compact);
    const b64 = btoa(unescape(encodeURIComponent(json)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    return '';
  }
}

export function decodeCart(token) {
  if (!token) return null;
  try {
    let s = token.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    const json = decodeURIComponent(escape(atob(s)));
    const arr = JSON.parse(json);
    return Array.isArray(arr) ? arr : null;
  } catch {
    return null;
  }
}

/**
 * Stable identifier for cart rows. Uses native crypto.randomUUID when
 * available (all modern browsers) and falls back to a timestamp+random
 * string otherwise. The uid lets React's reconciler track the same physical
 * row across removals, edits and reorders.
 */
export function newUid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `cfg-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
